import React from 'react';
import { Table } from 'antd';
import { connect } from 'react-redux';

class ChartTable extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render() {
        // const { messages } = this.props.intlr;
        const xAxisData = this.props.xAxisData;
        const seriesData = this.props.seriesData;
        let tableDataSource = [];
        let columns = [
            {
                title: this.props.xAxisName + ' \\ ' + this.props.yAxisName,
                dataIndex: 'name',
                key: 'name',
            },
        ];
        for (let i = 0; i < xAxisData.length; i++) {
            const typeItem = xAxisData[i];
            let tableDataSourceItem = {
                key: typeItem,
                name: typeItem
            };
            for (let i = 0; i < seriesData.length; i++) {
                const sourceItem = seriesData[i];

                for (let i = 0; i < sourceItem.data.length; i++) {
                    const item = sourceItem.data[i];
                    if (item[0] === typeItem) {
                        // 表格值为true，显示为1，false 显示为0, 与图表一致
                        if (item[1] === true) {
                            tableDataSourceItem[sourceItem.name] = 1;
                        } else if (item[1] === false) {
                            tableDataSourceItem[sourceItem.name] = 0;
                        } else {
                            tableDataSourceItem[sourceItem.name] = item[1];
                        }
                    }
                }
            }
            tableDataSource.push(tableDataSourceItem);
        }

        for (let i = 0; i < seriesData.length; i++) {
            const sourceItem = seriesData[i];
            columns.push({
                title: sourceItem.name,
                dataIndex: sourceItem.name,
                key: sourceItem.name,

            });
        }

        return (
            <div className="table-container">
                <Table
                    columns={columns}
                    dataSource={tableDataSource}
                    pagination={false}
                    size="middle"
                    bordered
                    rowClassName={
                        (record, index, indent) => {
                            if ((index - 1) % 2 == 0) {
                                return 'dark';
                            }
                        }
                    }
                />
            </div>

        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});

export default connect(
    mapStateToProps
)(ChartTable);